const closeButtonLabel = "Zatvori";
const hrHR = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  hrHR as default
};
